import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({
  children,
  moduleId,
  accessType = "read"
}) => {
  const { user, hasAccess, permissions } = useAuth();

  // ❌ Not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Super Admin full access
  if (user.role === "Super Admin") {
    return children;
  }

  // ✅ Prevent block before permissions load
  if (!permissions || permissions.length === 0) {
    return children;
  }

  // ❌ No permission
  if (moduleId && !hasAccess(moduleId, accessType)) {
    return (
      <div className="p-6 text-red-500 text-lg font-semibold">
        Access Denied
      </div>
    );
  }

  return children;
};

export default PrivateRoute;